import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ActivityCenterContainer from "@Broker/@Modules/sidebar/activity-center/components/activity-center-container.vue";
import ChatBot from "@Broker/@Modules/sidebar/chat-bot/components/chatbot.vue";
import GlobalSearchContainer from "@Broker/@Modules/sidebar/global-search/components/global-search-container";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { mapState } from "vuex";
import { ENVIRONMENT, PRIVACY_EXTERNAL_LINK, TOS_EXTERNAL_LINK } from "@Shared/@Utils/constants";
import { kebabCase } from "lodash";
import { logout } from "@Broker/@Modules/main/api/account-api";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "PageSidebar",
  components: {
    ActivityCenterContainer,
    GlobalSearchContainer,
    ProfileAvatar,
    ChatBot
  },
  props: {
    showSidebar: {
      type: Boolean,
      default: true
    }
  },
  computed: _objectSpread(_objectSpread({}, mapState("AccountStore", ["userDetails", "accountDetails", "permissions"])), {}, {
    fullName() {
      const {
        givenName,
        familyName
      } = this.userDetails;
      return `${givenName} ${familyName}`;
    },
    filteredMenu() {
      const {
        sections
      } = this.menu;
      return _mapInstanceProperty(sections).call(sections, section => {
        var _context;
        return _objectSpread(_objectSpread({}, section), {}, {
          tabs: _filterInstanceProperty(_context = section.tabs).call(_context, tab => this.accountCanAccess(tab))
        });
      });
    },
    menu() {
      return {
        sections: [{
          name: this.$t("sidebar.sections.overview"),
          tabs: [{
            name: this.$t("sidebar.sections.dashboard"),
            route: "dashboard",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.agents"),
            route: "agents",
            can: "brokerageAgents"
          }]
        }, {
          name: this.$t("sidebar.sections.clients"),
          tabs: [{
            name: this.$t("sidebar.sections.board"),
            route: "board",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.inactiveClients"),
            route: "inactive-clients",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.referrers"),
            route: "referrers",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.applications"),
            route: "applications",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.reports"),
            route: "reports",
            can: "all"
          }]
        }, {
          name: this.$t("sidebar.sections.financialTools"),
          route: "financial-tools",
          tabs: [{
            name: this.$t("sidebar.sections.mortgageCalculators"),
            route: "mortgage-calculators",
            can: "all"
          }]
        }, {
          name: this.$t("sidebar.sections.automation"),
          route: "automation",
          tabs: [{
            name: this.$t("sidebar.sections.viewAutomations"),
            route: "automations",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.documentAutomations"),
            route: "documents",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.dripCampaigns"),
            route: "drip-campaigns",
            can: "all"
          }]
        }, {
          name: this.$t("sidebar.sections.marketing"),
          route: "marketing",
          tabs: [{
            name: this.$t("sidebar.sections.lists"),
            route: "lists",
            can: "remarketingCampaign"
          }, {
            name: this.$t("sidebar.sections.templates"),
            route: "templates",
            can: "remarketingCampaign"
          }, {
            name: this.$t("sidebar.sections.campaigns"),
            route: "campaigns",
            can: "remarketingCampaign"
          }]
        }, {
          name: this.$t("sidebar.sections.settings"),
          tabs: [{
            name: this.$t("sidebar.sections.personalSettings"),
            route: "personal-settings",
            can: "all"
          }, {
            name: this.$t("sidebar.sections.brokerageSettings"),
            route: "brokerage-settings",
            can: "brokerageSettings"
          }, {
            name: this.$t("sidebar.sections.accountPlan"),
            route: "account-plan",
            can: "all"
          }]
        }, {
          name: this.$t("global.website.legal"),
          tabs: [{
            name: this.$t("global.doorr.tos"),
            route: TOS_EXTERNAL_LINK(),
            can: "all",
            type: "link"
          }, {
            name: this.$t("global.doorr.privacyPolicy"),
            route: PRIVACY_EXTERNAL_LINK(),
            can: "all",
            type: "link"
          }]
        }]
      };
    },
    accountTypeTitle() {
      return this.$tc(`global.doorr.${this.accountDetails.accountType}`, 1);
    }
  }),
  methods: {
    accountCanAccess(currentTab) {
      const {
        can
      } = currentTab;
      return can === "all" || this.permissions[can] !== "none";
    },
    getTabId(name) {
      return `${kebabCase(name)}-tab`;
    },
    getTabRoute(section, tab) {
      if (section) return `/${section}/${tab}`;
      return `/${tab}`;
    },
    isRouteExact(section, tab) {
      const route = section ? `/${section}/${tab}` : `/${tab}`;
      const exactRoutes = ["/automation/automations/document"];
      return _includesInstanceProperty(exactRoutes).call(exactRoutes, route);
    },
    ensureEnvironment(ignoreProduction) {
      return !ignoreProduction || ENVIRONMENT === "test";
    },
    logOut() {
      localStorage.removeItem("grant");
      localStorage.removeItem("user");
    },
    async handleLogout() {
      var _this$$auth, _this$$auth$session, _this$$auth$session$g, _this$$auth$session$g2;
      const token = (_this$$auth = this.$auth) == null ? void 0 : (_this$$auth$session = _this$$auth.session) == null ? void 0 : _this$$auth$session.get == null ? void 0 : (_this$$auth$session$g = _this$$auth$session.get()) == null ? void 0 : (_this$$auth$session$g2 = _this$$auth$session$g.xData) == null ? void 0 : _this$$auth$session$g2.ref;
      try {
        if (token) {
          await logout(token);
        }
      } catch (e) {
        console.error("Logout failed", e);
      }
      this.$auth.session.end();
    }
  }
});